import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const kanbanStyleId = 'wb-v2-kanban-theme';

export const kanbanBridgeStyles = {
  'kanban, w-kanban': {
    '--local-kanban-bg': 'transparent',
    '--local-kanban-surface': tokens.color.background.primary,
    '--local-kanban-surface-muted': tokens.color.background.tertiary,
    '--local-kanban-swimlane-header-bg': tokens.color.background.primary,
    '--local-kanban-swimlane-header-border': tokens.color.border.secondary,
    '--local-kanban-border': tokens.color.border.primary,
    '--local-kanban-border-subtle': tokens.color.border.secondary,
    '--local-kanban-border-selected': tokens.color.border.brand,
    '--local-kanban-text': tokens.color.text.primary,
    '--local-kanban-text-secondary': tokens.color.text.secondary,
    '--local-kanban-text-tertiary': tokens.color.text.tertiary,
    '--local-kanban-text-placeholder': tokens.color.text.placeholder,
    '--local-kanban-radius-xs': tokens.radius.xs,
    '--local-kanban-radius-sm': tokens.radius.sm,
    '--local-kanban-radius-md': tokens.radius.md,
    '--local-kanban-radius-full': tokens.radius.full,
    '--local-kanban-shadow-sm': 'none',
    '--local-kanban-shadow-lg': tokens.shadow.sm,
    '--local-kanban-card-hover-border': tokens.color.border.secondaryAlt,
    '--local-kanban-card-hover-shadow': tokens.shadow.sm,
    '--local-kanban-focus-ring': tokens.focusRing.default,
    '--local-kanban-column-width': '280px',
    '--local-kanban-card-width': '264px',
    '--local-kanban-board-padding-x': '16px',
    '--local-kanban-header-height': '48px',
    '--local-kanban-swimlane-header-height': '36px',
    '--local-kanban-column-header-bg': tokens.color.background.tertiary,
    '--local-kanban-column-header-count-text': tokens.componentColors.utility.gray700,
    '--local-kanban-gap-xs': tokens.spacing.xs,
    '--local-kanban-gap-xxs': tokens.spacing.xxs,
    '--local-kanban-gap-sm': tokens.spacing.sm,
    '--local-kanban-gap-md': tokens.spacing.md,
    '--local-kanban-gap-lg': tokens.spacing.lg,
    '--local-kanban-gap-xl': tokens.spacing.xl,
    '--local-kanban-font-family': tokens.font.family.body,
    '--local-kanban-font-family-display': tokens.font.family.display,
    '--local-kanban-font-size-sm': tokens.font.size.textSm,
    '--local-kanban-font-size-md': tokens.font.size.textMdBase,
    '--local-kanban-font-size-display-xs': tokens.font.size.displayXs,
    '--local-kanban-font-weight-regular': tokens.font.weight.regular,
    '--local-kanban-font-weight-medium': tokens.font.weight.medium,
    '--local-kanban-font-weight-semibold': tokens.font.weight.semibold,
    '--local-kanban-line-height-sm': tokens.lineHeight.textSm,
    '--local-kanban-line-height-md': tokens.lineHeight.textMd,
    '--local-kanban-line-height-display-xs': tokens.lineHeight.displayXs,
    '--local-kanban-header-count-bg': 'transparent',
    '--local-kanban-header-count-text': tokens.componentColors.utility.gray700,
    '--local-kanban-priority-urgent-bg': tokens.componentColors.utility.error50,
    '--local-kanban-priority-urgent-border': tokens.componentColors.utility.error400,
    '--local-kanban-priority-urgent-text': tokens.componentColors.utility.error700,
    '--local-kanban-card-selected-outline': `${tokens.borderWidth.md} solid ${tokens.color.border.brand}`,
    '--local-kanban-card-selected-border': `${tokens.borderWidth.sm} solid ${tokens.color.border.brand}`,
    '--local-kanban-card-selected-bg': tokens.color.background.active,
    '--local-kanban-card-selected-shadow': tokens.shadow.lg,
  },
};
